import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Button from 'common/Button/Button';
import { CardView, MobileButtonWrapper } from '../../Style';
import { parseTrainData } from 'UtilityComponents/trainUtil';
import { saveTrainData } from '../../../redux/actions/trainActionDispatcher';
import DisplayContext, { Devices } from 'UtilityComponents/displayContext';

function ConfirmationBox() {
	const dispatch = useDispatch();
	const [isDisabled, setDisabled] = useState(true);
	const passengers = useSelector((state) => state.train.passengerDetails || []);
	const trainDetailsFormData = useSelector((state) => state.train.trainDetails || []);
	const displayName = useContext(DisplayContext).isMobile;

	const isMobile = displayName == Devices.mobile;

	const submitHandler = () => {
		const apiRequest = parseTrainData(trainDetailsFormData, passengers);
		if (apiRequest) {
			dispatch(saveTrainData(apiRequest));
		}
	};

	const { fromCity, toCity, boardingStation, travelDate, reservationType, classType } = trainDetailsFormData;

	useEffect(() => {
		const values = Object.values(trainDetailsFormData);
		let error = false;
		const formvalues = Object.values(values);
		for (let i = 0; i < formvalues.length; i++) {
			if (i > 1) {
				error = !formvalues[i];
				if (error) {
					break;
				}
			}
		}
		const disabledState = error || passengers.length === 0;
		setDisabled(disabledState);
	}, [fromCity, toCity, boardingStation, travelDate, reservationType, classType, passengers, trainDetailsFormData]);

	const mobileButton = (
		<MobileButtonWrapper>
			<Button
				btnTxt='REQUEST TO BOOK'
				btnName='Primary'
				handleClick={submitHandler}
				disabled={isDisabled}
			/>
		</MobileButtonWrapper>
	);

	const button = (
		<CardView>
			<Button
				btnWidth='28%'
				btnTxt='REQUEST TO BOOK'
				btnType='Capsule'
				btnName='Primary'
				handleClick={submitHandler}
				disabled={isDisabled}
			/>
		</CardView>
	);

	return (
		isMobile ? mobileButton : button
	);
}

export default ConfirmationBox;
